var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDownLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.6 5.268a.8.8 0 0 1 1.133 1.13l-6.968 6.969h6.401a.8.8 0 0 1 0 1.6H5.833a.8.8 0 0 1-.8-.8V5.832a.8.8 0 1 1 1.6 0v6.403z"
})));
SvgArrowDownLeft.displayName = "SvgArrowDownLeft";
export { SvgArrowDownLeft as ReactComponent };
export default SvgArrowDownLeft;